import React, { FC } from 'react';

const IconCerdito: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      {...props}
    >
      <title>Icon / cerdito</title>
      <g id="Clip-2" />
      <g>
        <path
          d="M22.463,11.157v1.043c0.263,0,0.477,0.216,0.477,0.482c0,0.267-0.214,0.481-0.477,0.481
		c-0.298,0-0.459-0.134-0.739-0.389c-0.285-0.262-0.641-0.582-1.219-0.609c-0.26-2.592-2.751-5.16-4.689-6.169
		c-0.281,0.507-0.684,0.948-1.174,1.296c-0.724,0.654-1.677,1.053-2.723,1.053c-1.628,0-3.035-0.965-3.697-2.357
		C8.12,5.807,8.034,5.615,7.967,5.417C7.892,5.443,7.815,5.463,7.744,5.493C6.072,6.187,6.932,5.792,6.547,5.97
		C6.543,5.953,6.542,5.94,6.538,5.923c-0.813-3.486-5.013-2.5-5.013-2.5S1.38,6.937,3.942,7.754c-0.684,0.674-1.233,1.44-1.602,2.28
		H1.07c-0.575,0-1.042,0.471-1.042,1.052v3.093c0,0.58,0.467,1.052,1.042,1.052h1.301c0.601,1.33,1.644,2.481,2.979,3.347
		l-0.805,2.039c-0.213,0.54,0.048,1.152,0.582,1.367l1.028,0.415c0.534,0.215,1.141-0.049,1.353-0.589l0.769-1.947
		c0.908,0.238,1.876,0.368,2.883,0.368c1.192,0,2.327-0.188,3.376-0.519l0.828,2.098c0.213,0.54,0.819,0.804,1.354,0.589
		l1.027-0.415c0.533-0.215,0.794-0.827,0.581-1.367l-0.922-2.338c1.74-1.269,2.89-3.056,3.088-5.064
		c0.179,0.021,0.312,0.128,0.538,0.335c0.305,0.277,0.722,0.658,1.432,0.658c0.832,0,1.509-0.684,1.509-1.525
		C23.971,11.842,23.295,11.157,22.463,11.157z M6.924,13.11c-1.087,0-1.968-0.881-1.968-1.968c0-1.086,0.881-1.968,1.968-1.968
		c1.086,0,1.968,0.881,1.968,1.968C8.891,12.229,8.01,13.11,6.924,13.11z"
        />
        <path
          d="M11.928,7.129c1.59,0,2.877-1.251,2.959-2.82c0.003-0.053,0.016-0.102,0.016-0.155
		c0-1.643-1.331-2.975-2.975-2.975c-1.643,0-2.976,1.332-2.976,2.975c0,0.053,0.014,0.103,0.016,0.155
		C9.052,5.878,10.339,7.129,11.928,7.129z"
        />
        <circle fill="#FFFFFF" cx="6.924" cy="11.142" r="1.968" />
      </g>
    </svg>
  );
};

export default IconCerdito;
